// 购物车本地缓存（sessionStorage，刷新清空）
const CART_KEY = 'mall_cart'

export function getCart() {
  try {
    return JSON.parse(sessionStorage.getItem(CART_KEY) || '[]')
  } catch (e) {
    return []
  }
}

export function saveCart(cart) {
  sessionStorage.setItem(CART_KEY, JSON.stringify(cart))
}

// 折后售价:有折扣价(且小于零售价)取折扣价,否则取零售价
function sellPrice(product) {
  return (product && product.discountPrice != null && Number(product.discountPrice) < Number(product.retailPrice))
    ? product.discountPrice : product.retailPrice
}

// 加入购物车（同商品累加数量）
export function addToCart(product, quantity) {
  const cart = getCart()
  const idx = cart.findIndex(i => i.productId === product.id)
  if (idx >= 0) {
    cart[idx].quantity += quantity
  } else {
    cart.push({
      productId: product.id,
      productName: product.productName,
      mainImg: product.mainImg,
      spec: product.spec,
      unit: product.unit,
      price: sellPrice(product),
      quantity: quantity
    })
  }
  saveCart(cart)
}

export function updateQty(productId, quantity) {
  const cart = getCart()
  const item = cart.find(i => i.productId === productId)
  if (item) {
    item.quantity = Math.max(1, quantity)
    saveCart(cart)
  }
}

export function removeItem(productId) {
  const cart = getCart().filter(i => i.productId !== productId)
  saveCart(cart)
}

export function clearCart() {
  sessionStorage.removeItem(CART_KEY)
}

export function getCartCount() {
  return getCart().reduce((s, i) => s + i.quantity, 0)
}

export function getCartTotal() {
  return getCart().reduce((s, i) => s + Number(i.price) * i.quantity, 0)
}
